import * as React from 'react'
import Box from '@mui/material/Box'
import InputLabel from '@mui/material/InputLabel'
import OutlinedInput from '@mui/material/OutlinedInput'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { allMonths, monthsHas31days, monthsHas30Days, days31, days30, days29, year } from '../utils/datePicker'

export default function PickDateWithoutShiftGrow(props) {
	const { setTime, time } = props
	const [date, setDate] = React.useState(days31)

	const handleChange = (event) => {
		const { name, value } = event.target
		if (name === 'month') {
			if (value === '2') {
				setDate(days29)
			} else if (monthsHas31days.includes(value)) {
				setDate(days31)
			} else if (monthsHas30Days.includes(value)) {
				setDate(days30)
			}
		}
		const newValue = { ...time, [name]: value }
		setTime(newValue)
	}

	React.useEffect(() => {
		const value = time.month
		if (value === '2') {
			setDate(days29)
		} else if (monthsHas31days.includes(value)) {
			setDate(days31)
		} else if (monthsHas30Days.includes(value)) {
			setDate(days30)
		}
	}, [time])

	return (
		<Box>
			<Box sx={{ pl: 0, pr: 0, mb: 1 }}>
				<Box
					component='form'
					sx={{
						display: 'flex',
						flexWrap: 'wrap',
						pt: 0,
						justifyContent: 'center',
						alignItems: 'flex-end',
					}}>
					<FormControl sx={{ mr: 1, minWidth: 75, mt: 2 }} size='small'>
						<InputLabel id='select-label'>Ngày</InputLabel>
						<Select
							labelId='select-label'
							id='date-select'
							value={time.date}
							name='date'
							onChange={handleChange}
							sx={{ borderRadius: '10px' }}
							input={<OutlinedInput label='Ngày' />}>
							{date?.map((date, index) => {
								return (
									<MenuItem key={index} value={date}>
										{date}
									</MenuItem>
								)
							})}
						</Select>
					</FormControl>
					<FormControl sx={{ mr: 1, minWidth: 85, mt: 2 }} size='small'>
						<InputLabel id='select-label'>Tháng</InputLabel>
						<Select
							labelId='select-label'
							id='date-select'
							value={time.month}
							name='month'
							onChange={handleChange}
							sx={{ borderRadius: '10px' }}
							input={<OutlinedInput label='Tháng' />}>
							{allMonths?.map((month, index) => {
								return (
									<MenuItem key={index} value={month}>
										{month}
									</MenuItem>
								)
							})}
						</Select>
					</FormControl>
					<FormControl sx={{ minWidth: 80, mt: 2 }} size='small'>
						<InputLabel id='select-label'>Năm</InputLabel>
						<Select
							labelId='select-label'
							id='date-select'
							value={time.year}
							name='year'
							onChange={handleChange}
							sx={{ borderRadius: '10px' }}
							input={<OutlinedInput label='Năm' />}>
							{year.map((year, index) => {
								return (
									<MenuItem key={index} value={year}>
										{year}
									</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Box>
			</Box>
		</Box>
	)
}
